import type { Route } from '~/interfaces/routes.interfaces'

export const BASE_URL_SETTING = '/settings'

const base = BASE_URL_SETTING

export const SETTINGS_FINANCIAL_INDICATORS: Route = {
  path: `${base}/financial-indicators`
}

export const SETTINGS_LOGS: Route = {
  path: `${base}/logs`
}

export const SETTINGS_STATS: Route = {
  path: `${base}/stats`
}
